'use strict';
define(['./LazyLoad', '../../../../lib/domQ', './Level3', './XSmallDevice', './DesktopDevice', './Breakpoint'], function (Lazyload, domQ, Level3, XSmallDevice, DesktopDevice, breakpoint) {

    var IS_LEVEL2_ACTIVE = 'navigation-is-level2-active';
    var IS_ACTIVE = 'navigation-is-active';
    var ARIA_EXPANDED = 'aria-expanded';
    var IS_ACTIVE_SUBMENU = 'navigation-is-active-submenu';
    var IS_ACTIVE_ANCHOR = 'navigation-is-active-anchor';
    var clickedMenu;
    var menuBarOver = false;
    function Level2(config, auth) {
        this.config = config;
        this.auth = auth;
        this.navPrimarySectionEl = document.querySelector('.navigation-primary__section');
        this.navPaneOneBottomEl = document.querySelector('.navigation-pane-one-navbottom');
        this.navContainerEl = document.getElementById('navContainer');
        this.navPrimaryAList = document.querySelectorAll('.navigation-primary__section > .nav-primary__list a[id$=_menu]');
        this.searchDropdown = document.querySelector('.navigation-search-bar--suggestion-dropdown');
        this.navVeilEl = document.querySelector('.navigation-nav-veil');
        this.primaryList = document.querySelector('.nav-primary__list');
        this.headerEL = document.querySelector('.navigation-common-hdr-main');
        this.bindForDevice = this.bindForDevice.bind(this);
        this.checkClickToClose = this.checkClickToClose.bind(this);
        this.lazyload = new Lazyload();
        this.init();
        this.activateBarMenu = this.activateBarMenu.bind(this);
        this.load = this.load.bind(this);
    }
    Level2.prototype.init = function () {
        var _this = this;
        this.level3 = new Level3(this.config);
        var NavL23DataDate = 'NavL23DateUK';
        var urlloc = window.location.href.split('.')[0];
        if (urlloc === 'https://store' || urlloc === 'https://cs') {
            window.MS_COMMON_L23CMDCALL = false;
        }
        if (window.mnsHeaderConfig && window.mnsHeaderConfig.storeId === '10451') {
            NavL23DataDate = 'NavL23DateIE';
        }
        if (window && window.MS_COMMON_L23CMDCALL) {
            if (window.localStorage && window.localStorage[NavL23DataDate]) {
                var today = new Date();
                var timeDiff = Math.round((today.getTime() - Date.parse(window.localStorage[NavL23DataDate])) / (1000 * 60));
                if (!window.navXhrDuration) {
                    window.navXhrDuration = 15;
                }
                if (timeDiff < window.navXhrDuration) {
                    this.level3.loadStatic();
                    this.load();
                }
                else {
                    return this.level3.load()
                        .then(_this.load.bind(_this))
                        .catch(function () {
                            //Handle errors here
                        });
                }
            } else {
                return this.level3.load()
                    .then(_this.load.bind(_this))
                    .catch(function () {
                        //Handle errors here
                    });
            }
        }
        if (!window.MS_COMMON_L23CMDCALL) {
            this.level3.load();
            this.load();
        }
    };
    Level2.prototype.load = function () {
        var _this = this;
        window.addEventListener('resize', _this.bindForDevice);
        _this.bindForDevice();
        _this.lazyload.bind();
        _this.activateBarMenu();
        _this.newTag();
        /* Identify single column in six column nav submenu and allocate 100 percent width using fullwidth class*/
        var navSubmenu = document.querySelectorAll('.nav-submenu__span--one-fifth');
        for (var navSubmenuIndex = 0; navSubmenuIndex < navSubmenu.length; navSubmenuIndex++) {
            var subMenuColElements = navSubmenu[navSubmenuIndex].getElementsByClassName('nav-submenu__col');
            if(subMenuColElements.length === 1){
                subMenuColElements[0].classList.add('fullwidth');
            }
        }
    };
    Level2.prototype.newTag = function () {
        var today = new Date();
        var newTagEl = document.querySelectorAll('.new-tag');
        for(var indivEl = 0;indivEl < newTagEl.length;indivEl++){
            if(newTagEl[indivEl].hasAttribute('data-newtagdate')){
                var newTagDataAttr = newTagEl[indivEl].getAttribute('data-newtagdate');
                var newTagData = new Date(newTagDataAttr);
                var diffTime = today - newTagData;
                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                if(diffDays>=1 && diffDays<=21){
                    newTagEl[indivEl].setAttribute('aria-label',newTagEl[indivEl].innerText +' new brand');
                    newTagEl[indivEl].innerText = newTagEl[indivEl].innerText + ' ';
                    newTagEl[indivEl].classList.add('new-tag-style');
                }
            }
        }
    };
    Level2.prototype.bindForDevice = function () {
        if (breakpoint.size() === 'xsmall') {
            if (!this.xSmallDevice) {
                this.xSmallDevice = new XSmallDevice(this);
            }
            this.xSmallDevice.bind();
            if (this.desktopDevice) {
                this.desktopDevice.unbind();
                this.desktopDevice.countrySelectorOverlayCloseOnResize();
            }
        }
        else {
            if (!this.desktopDevice) {
                this.desktopDevice = new DesktopDevice(this, this.level3);
            }
            this.desktopDevice.bind();
            this.desktopDevice.countrySelectorOverlayCloseOnResize();
            if (this.xSmallDevice) {
                this.xSmallDevice.unbind();
            }
        }
    };
    /*Identify the menu value in windows path url which need to be highlighted  in menu bar*/
    Level2.prototype.identifyMenu = function () {
        if (window.location && window.location.pathname && window.location.pathname.indexOf('/ie') !== -1) {
            if (window.pdpData && window.pdpData.breadcrumb && window.pdpData.breadcrumb[1] && window.pdpData.breadcrumb[1].categoryUrl) {
                clickedMenu = window.pdpData.breadcrumb[1].categoryUrl.split('/')[3];
            }
            else if (window.utag_data && window.utag_data.page_type && window.utag_data.project_type && window.utag_data.page_type === 'Product Detail Page' && window.utag_data.project_type === 'fesk') {
                window.navAnchorPdpData = { breadcrumb: [] };
                window.navAnchorPdpData.breadcrumb = document.querySelectorAll('.breadcrumb li [href]');
                clickedMenu = window.navAnchorPdpData.breadcrumb && window.navAnchorPdpData.breadcrumb[1].pathname ? window.navAnchorPdpData.breadcrumb[1].pathname.split('/')[3] : null;
            }
            else if (window.location.pathname.split('/ie')[1] && (window.location.pathname.split('/')[2] !== 'sitemaps') && (window.location.pathname.split('/')[2] !== 'Sitemaps')) {
                clickedMenu = window.location.pathname.split('/ie')[1].split('/')[2];
            }
        } else {
            if (window.pdpData && window.pdpData.breadcrumb && window.pdpData.breadcrumb[1] && window.pdpData.breadcrumb[1].categoryUrl) {
                clickedMenu = window.pdpData.breadcrumb[1].categoryUrl.split('/')[2];
            }
            else if (window.utag_data && window.utag_data.page_type && window.utag_data.project_type && window.utag_data.page_type === 'Product Detail Page' && window.utag_data.project_type === 'fesk') {
                window.navAnchorPdpData = { breadcrumb: [] };
                window.navAnchorPdpData.breadcrumb = document.querySelectorAll('.breadcrumb li [href]');
                clickedMenu = window.navAnchorPdpData.breadcrumb && window.navAnchorPdpData.breadcrumb[1].pathname ? window.navAnchorPdpData.breadcrumb[1].pathname.split('/')[2] : null;
            }
            else if (window.location && window.location.pathname && (window.location.pathname.split('/')[1] !== 'sitemaps') && (window.location.pathname.split('/')[1] !== 'Sitemaps')) {
                clickedMenu = window.location.pathname.split('/')[2];
            }
        }
        //Differes the sale and offers menu url value
        if (clickedMenu === 'offers' && 'sale' === window.location.pathname.split('/')[3]) {
            clickedMenu = 'sale';
        }
    },
        /*Remove the active bar class for other menus*/
        Level2.prototype.removeActiveMenu = function (element) {
            if (element.classList.contains(IS_ACTIVE_SUBMENU)) {
                element.classList.remove(IS_ACTIVE_SUBMENU);
                element.parentElement.classList.remove(IS_ACTIVE);
            }
        },
        /**
         * Method is using to highlit the GNAV bar
         * Identify the menu value in windows path url which need to be highlighted  in menu bar
         * compare the menu value to menu bar list and add the active bar class
         */
        Level2.prototype.activateBarMenu = function () {
            this.identifyMenu();
            for (var iCount = 0; iCount < this.navPrimaryAList.length; iCount++) {
                var element = this.navPrimaryAList[iCount];
                var categoryEl = '';
                if (element.getAttribute('href') && element.getAttribute('href').indexOf('/ie') !== -1) {
                    categoryEl = (element.getAttribute('href').split('/ie')[1]);
                    categoryEl = categoryEl.split('#')[0];
                }
                else {
                    categoryEl = element.getAttribute('href');
                    if(categoryEl){
                        categoryEl = categoryEl.split('#')[0];
                    }
                }
                if ((clickedMenu && 'offers' !== clickedMenu && clickedMenu === categoryEl.split('/')[2]) || (('sale' === clickedMenu || 'offers' === clickedMenu) && clickedMenu === element.innerText.toLowerCase())) {
                    domQ(element).addClass(IS_ACTIVE_SUBMENU);
                    domQ(element).addClass(IS_ACTIVE_ANCHOR);
                    domQ(element.parentElement).addClass(IS_ACTIVE);
                }
                else {
                    this.removeActiveMenu(element);
                }
            }
        };
    Level2.prototype.checkClickToClose = function (e) {
        if (!e.target.classList.contains('nav-primary__menu-link')) {
            this.deactivate();
        }
    };

    Level2.prototype.activate = function (el) {
        var searchDropPassive = this.searchDropdown ? this.searchDropdown.classList.contains('navigation-search-bar--suggestion-dropdown__hidden') : true;
        if (!searchDropPassive) {
            this.searchDropdown.classList.add('navigation-search-bar--suggestion-dropdown__hidden');
        }
        this.level3.hideAllPanels();
        this.level3.showPanel(this.level3.getPanelId(el.id));
        domQ(this.navPrimarySectionEl).addClass(IS_LEVEL2_ACTIVE);
        domQ(this.navContainerEl).addClass(IS_ACTIVE);
        domQ(this.navPaneOneBottomEl).addClass(IS_LEVEL2_ACTIVE);
        menuBarOver = true;
        this.deactivateAllMenus();
        domQ(el).addClass(IS_ACTIVE);
        domQ(el.parentElement).addClass(IS_ACTIVE);
        this.navVeilEl.classList.add(IS_ACTIVE);
        if (breakpoint.size() === 'xsmall') {
            el.setAttribute(ARIA_EXPANDED, true);
        }
        this.lazyload.load();
        this.primaryList.style.zIndex = '90001';
    };
    Level2.prototype.deactivate = function () {
        domQ(this.navPrimarySectionEl).removeClass(IS_LEVEL2_ACTIVE);
        domQ(this.navContainerEl).removeClass(IS_ACTIVE);
        domQ(this.navPaneOneBottomEl).removeClass(IS_LEVEL2_ACTIVE);
        menuBarOver = false;
        this.deactivateAllMenus();
        this.activateBarMenu();
        this.level3.hideAllPanels();
        this.primaryList.removeAttribute('style');
    };
    Level2.prototype.deactivateAllMenus = function () {
        for (var iCount = 0; iCount < this.navPrimaryAList.length; iCount++) {
            var el = this.navPrimaryAList[iCount];
            domQ(el).removeClass(IS_ACTIVE);
            domQ(el.parentElement).removeClass(IS_ACTIVE);
            if (breakpoint.size() !== 'xsmall') {
                this.navVeilEl.classList.remove(IS_ACTIVE);
            }
            if (breakpoint.size() === 'xsmall') {
                el.setAttribute(ARIA_EXPANDED, false);
            }
            if (menuBarOver) {
                domQ(el).removeClass(IS_ACTIVE_SUBMENU);
            }
        }
    };

    return Level2;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/Level2.js